<template>
    <section class="view" v-if="hasPermissions(['Associate-Permissions-Template Read'])">
        <Breadcrumb :breadcrumb="breadcrumb"/>
        <h1 class="view__title title--1">
            {{ title_page }}
        </h1>
        <div class="view__description">
            <p class="view__description__text">
                This is a list of permissions templates in the facility.
            </p>
        </div>

        <div class="bar-container">
            <div class="bar-container__search-bar">
                <div class="input-field my-0" v-if="hasPermissions(['Associate-Permissions-Template Read'])">
                    <i class="material-icons prefix iconInput">search</i>
                    <input id="icon_prefix" type="text" class="validate inputSearch" placeholder="Search" v-model="search">
                </div>
            </div>
            <div class="bar-container__options">
                <button v-if="hasPermissions(['Associate-Permissions-Template Write'])" class="modal__buttons__item btn-width-4" v-html="'Mass Delete'" :class="{'disabled button__disabled' : !selected}" :disabled="!selected" @click="massive_modal_delete()"/>
            </div>

            <div v-if="hasPermissions(['Associate-Permissions-Template Write'])" class="bar-container__cta">
                <span class="button__modal text-right">
                    <a href="#" @click="form_modal()" class="d-inline-md-block">
                        {{ add_btn }}
                        <i class="prefix ml-1">
                            <img src="/assets/img/svg/add.svg" alt="date" style="width: 15px">
                        </i>
                    </a>
                </span>
            </div>
        </div>

        <div class="tab-content" v-show="permissions_templates.length && hasPermissions(['Associate-Permissions-Template Read'])">
            <div class="tab-pane fade active show" id="listation">
                <div class="row mb-0 no-gutters">
                    <div class="col-lg-12">
                        <v-card>
                            <DinamicTable
                                :headers="table_headers"
                                :items="permissions_templates"
                                :search="search"
                                :checkable="true"
                                :link="'#'"
                                :updateable="true"
                                @emitToUpdate="modal_update($event)"
                            />
                        </v-card>
                    </div>
                </div>
            </div>
        </div>

        <DeletionMassiveModal
            @objectDeletion="massive_local_emition($event)"
        />

        <FormModal 
            :title="'New Associate'"
            :breadcrumb="breadcrumb"
            :rest_api="rest_api"
            :notyf="notyf"
            :axios="axios"
            :array_options="array_options"
            :permissions="permissions"
            @unshiftObject="unshift_object($event)"
            ref="form_modal"
            name="form_modal"
        />

        <UpdateModal 
            :title="'Associate Update'"
            :breadcrumb="breadcrumb"
            :rest_api="rest_api"
            :notyf="notyf"
            :axios="axios"
            :single_object="single_object"
            :global_index="global_index"
            :array_options="array_options"
            :permissions="permissions"
            @spliceObject="splice_object($event)"
            ref="update_modal"
            name="update_modal"
        />

        <DeletionValidationModal 
        :validation_table_headers="deletion_validation_table_headers"
        :validate_data="validate_data"
        :breadcrumb="breadcrumb"
        message="The following permissions templates were not deleted because there are associates linked to them. Please note that these associates may also be linked to items in the recycle bin."
        />

        <HelperModal :helps="helps"/>

        <WaitingModal/>


  </section>
  <div v-else>
    <UnauthorizedComponent :breadcrumb="breadcrumb"/>
  </div>
</template>

<script>

import axios                    from    'axios';
import Breadcrumb               from    '@/components/BreadcrumbComponent/Breadcrumb'
import WaitingModal             from    '@/components/WaitingModal'
import HelperModal              from    '@/components/HelperModal'
import Resources                from    './resources'
import FormModal                from    './FormModal'
import UpdateModal              from    './UpdateModal'
import DeletionMassiveModal     from    '@/components/DeletionMassiveModal'
import DeletionValidationModal          from    '@/components/DeletionValidationModal'
import DinamicTable             from    '@/components/DinamicTable'
import UnauthorizedComponent    from   '@/components/UnauthorizedComponent'
import { Notyf }                from    'notyf';
import 'vuetify/dist/vuetify.min.css'
import 'notyf/notyf.min.css'; // for React and Vue
const notyf = new Notyf({
    duration: 8000,
});

export default {

    name:   'PermissionsTemplate',

    components:{
        Breadcrumb,
        WaitingModal,
        FormModal,
        DeletionMassiveModal,
        DeletionValidationModal,
        UpdateModal,
        DinamicTable,
        UnauthorizedComponent,
        HelperModal
    },

    data(){
        return{
            notyf,
            axios,
            child_href:             '/permissions-template-detail/',
            user:                   this.get_user(),
            title_page:             'Permissions Templates',
            rest_api:               'permissions_templates',
            table_headers:          Resources.table_headers,
            breadcrumb:             Resources.breadcrumb,
            deletion_validation_table_headers: Resources.deletion_validation_table_headers,
            add_btn:                'Add Template',
            single_select:          false,
            table_selection:        [],
            search:                 '',
            global_index:           null,
            single_object:          {},
            permissions_templates:  [],
            array_options:          {},
            permissions:            [],
            select_ids:             [],
            helps:                  Resources.helps,
            validate_data:          []

            
        }
    },

    methods:{
        unshift_object()
        {
            this.api_request()
        },
    
        splice_object()
        {
            this.api_request()
        },

        modal_deletion(index)
        {
            this.global_index  = index
            this.single_object = this.associates[index]
            window.$('#static-deletion').modal('show')
        },

        form_modal()
        {
            window.$('#static').modal('show')
            this.$refs.form_modal.reset()
        },

        modal_update(index)
        {
            this.global_index  = index
            this.single_object = this.permissions_templates[index]
            window.$('#static-update').modal('show')
            this.$refs.update_modal.reset()
        },

        fill_data(data)
        {
            this.permissions = data.permissions
            this.permissions_templates = data.permissions_templates

            this.array_options = {
                
            }
        },


        massive_modal_delete()
        {
            this.select_ids = this.permissions_templates.filter(item => item.checked)
            console.log(this.select_ids)

            if(this.select_ids.length)
            {
                window.$('#static-deletion-massive').modal('show')
            }
        },

        async massive_local_emition()
        {
            let json_request = {
                ids:         this.select_ids,
            }

            this.loader(true)

            let response = await this.post(`${this.rest_api}/massive_delete`, json_request)

            this.loader()

            if(response)
            {
                const validation_data = response.data.validated_permissions_templates

                if(validation_data.length)
                {
                    window.$('#deletion-validations').modal('show')
                    this.validate_data = validation_data
                }

                window.$('#static-deletion-massive').modal('hide')

                response.data.deleted_ids.forEach( item =>
                {
                    const index = this.permissions_templates.findIndex(value => value.id == item)
                    if(index > -1)
                    {
                        this.permissions_templates.splice(index, 1)
                    }
                })

                this.select_ids = []
            }
        },
        

    },

    async mounted()
    {
        if(this.hasPermissions(['Associate-Permissions-Template Read']))
        {
            await this.api_request()
        }
    },

    computed:
    {
         selected()
        {
            const bool = this.permissions_templates.filter(item => item.checked)
            return Boolean(bool.length)
        }
    }
}
</script>